import useCourierHook from "@/shared/hooks/useCourier";
import useCouriersHook from "@/shared/hooks/useCouriersHook";
import useAssignCourierToOrderMutation from "@/shared/mutations/orders/useAssignCourierToOrderMutation";
import useUnassignHook from "@/shared/mutations/orders/useUnassignHook";
import { CmsUsersResponse } from "@/shared/utils/interfaces";
import { OrderV2 } from "@/shared/v2/queries/interfacesV2";
import { useState } from "react";
import Search from "../Input/Search";
import { useTranslation } from "react-i18next";
const List = ({ selected, className = "", ...props }) => (
  <div
    className={`cursor-pointer p-4 ${className}`.trim()}
    style={{ border: `1px solid var(--${selected ? "primary" : "grey"})` }}
    {...props}
  />
);

interface Props {
  initialDriver: number;
  order: OrderV2;
  onAssignedOrUnassigned?: () => void;
}

const Driver = ({ initialDriver, order, onAssignedOrUnassigned }: Props) => {
  const { onUnassign, option } = useUnassignHook();
  const couriers = useCouriersHook();
  const { t } = useTranslation();
  const mutate = useAssignCourierToOrderMutation(
    order.order_information.branch_id
  );
  const [selected, setSelected] = useState(initialDriver);
  const courier = useCourierHook(selected);
  const [search, setSearch] = useState("");
  const handleClick = (driver: CmsUsersResponse) => {
    setSelected(driver.item_id);
    mutate.mutateAsync(
      {
        orderId: order.order_information.item_id,
        courierId: driver.item_id,
      },
      { onSuccess: () => onAssignedOrUnassigned?.() }
    );
  };

  return (
    <div>
      <div className="flex items-center py-4">
        <div className="md:mr-[1rem]" style={{ fontWeight: "bold" }}>
          {selected === -1 || !courier?.name
            ? `${t("noCourierSelected")}`
            : ` ${t("currentCourier")}: ${courier?.name}`}
        </div>
        <div className="flex-[1_0_auto]">
          <Search
            placeholder={t("orders_live.searchCourier")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onDeleteClick={() => setSearch("")}
          />
        </div>
      </div>
      <div className="h-150 overflow-auto">
        {selected !== -1 && (
          <List
            onClick={() => {
              onUnassign(-1, [order.order_information.item_id]);
              setSelected(-1);
              onAssignedOrUnassigned?.();
            }}
            selected={selected === -1}
          >
            {option.name}
          </List>
        )}
        {couriers
          .filter((driver) =>
            search !== ""
              ? driver.name.toLocaleLowerCase().includes(search.toLowerCase())
              : true
          )
          .map((driver) => (
            <List
              onClick={() => handleClick(driver)}
              selected={selected === driver.item_id}
              key={driver.item_id}
            >
              {driver.name}
            </List>
          ))}
      </div>
    </div>
  );
};

export default Driver;
